import React from 'react'
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton'
import Tooltip from "@material-ui/core/Tooltip";
import SendIcon from '@material-ui/icons/Send';
// import ClassEditor from 'components/Store/ClassEditor'

function ShareButton(props) {

    // const [open, setOpen] = React.useState(false)
    // React.useState(props.new ? true : false)
    const {link} = props
    const {buttonText} = props
    
    const [showCopyLink, setCopyLink] = React.useState(false);
    function handleLinkClick(e) {
        e.preventDefault()
        var input = document.createElement('input');
        input.setAttribute('value', link);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setCopyLink(true);

        setTimeout(function() {
        setCopyLink(false);
        }, 2000);
    }
 
    return (<>
        {buttonText ? (
            <div className={props.className} style={props.style}>
                <Tooltip open={showCopyLink} title={showCopyLink ? "Copied!" : "Copy"}>
                
                    <button onClick={handleLinkClick} className="btn btn-outline-primary primaryColor w-100">
                        <SendIcon className="mr-2" />
                        <span>{buttonText}</span>
                    </button>
                </Tooltip>
            </div>
            
        ) : (

        <div className={props.className} style={props.style}>
            <Tooltip open={showCopyLink} title={showCopyLink ? "Copied!" : "Copy"}>
                <IconButton onClick={handleLinkClick}>
                    <FileCopyIcon/>    
                </IconButton>
                {/* <NavLink id="widgetLink" href="" onClick={handleWidgetLinkClick}>
                
                </NavLink> */}
            </Tooltip>
            
            {/* <button onClick={() => setOpen(true)} className="btn btn-link">
                Edit
            </button> */}
        </div>

        )}
    </>);
}

export default ShareButton